import axios from "axios";

const getAuthToken = () => "Bearer " + localStorage.getItem("token");

// API config
const PLAYER_COMPLAINS = axios.create({
    baseURL: "https://api.tvcom.uz/api/v1.2.0",
});

export const getComplains = async (type) => {
    try {
        const res = await PLAYER_COMPLAINS.get("/problems", {
            headers: {
                Authorization: getAuthToken(),
            },
            params: {
                type: type,
            },
        });
        return res.data;
    } catch (error) {
        console.log(error);
    }
};

export const setComplains = async (body, type) => {
    try {
        const res = await PLAYER_COMPLAINS.post("/complaints", body, {
            headers: {
                Authorization: getAuthToken(),
            },
            params: {
                type: type,
                device: "browser",
            },
        });
        return res.data;
    } catch (error) {
        console.log(error);
    }
};
